/** Apps that have isolated translation sets in DeviceLang (`appId`). */
export const TRANSLATION_APP_IDS = [1, 2] as const;

export type TranslationAppId = (typeof TRANSLATION_APP_IDS)[number];

export const TRANSLATION_APP_LABELS: Record<TranslationAppId, string> = {
  1: 'Life Experience',
  2: 'Life Suite',
};

export function isTranslationAppId(value: number): value is TranslationAppId {
  return value === 1 || value === 2;
}

export function parseTranslationAppIdParam(
  raw: string | undefined
): TranslationAppId | null {
  const n = Number(raw);
  if (!Number.isFinite(n) || !Number.isInteger(n)) return null;
  return isTranslationAppId(n) ? n : null;
}
